module.exports = __webpack_public_path__ + "media/img/frontend_application/free_trial/icon-venue-lg-7f9e5a81a2109f26974068647e63369a.png";